import React, { useState, useEffect } from "react";
import Web3 from "web3"

export function getWeb3() {
	if (Web3.givenProvider) {
		const web3 = new Web3(Web3.givenProvider)
		return [true, web3]
	}
	return [false, undefined]
}

